import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { SignInputCountry, SignInputUserType, WithLabel } from '@/module/auth/sign-up';
import { type UserType } from '@/types';
import { Input } from '@/ui';
import { type ProfileEditFormData } from '../schema';
const INPUT_MAX_LENGTH = 14;
export const CommonEditForm = () => {
  const {
    getValues
  } = useFormContext<ProfileEditFormData>();
  const userType = getValues('userType');
  return <>
      <NicknameInput data-sentry-element="NicknameInput" data-sentry-source-file="CommonEditForm.tsx" />
      <SignInputUserType type={userType as UserType} isTypeChangeable={false} data-sentry-element="SignInputUserType" data-sentry-source-file="CommonEditForm.tsx" />
      <SignInputCountry data-sentry-element="SignInputCountry" data-sentry-source-file="CommonEditForm.tsx" />
    </>;
};
const NicknameInput = () => {
  const {
    register,
    getValues,
    formState: {
      errors
    }
  } = useFormContext<ProfileEditFormData>();
  const {
    t
  } = useTranslation(['common']);
  const email = getValues('email');
  const errorMessage = errors.userName?.message ? t('account.signup.requiredField') : undefined;
  return <div className="flex flex-col gap-xs" data-sentry-component="NicknameInput" data-sentry-source-file="CommonEditForm.tsx">
      <WithLabel label={t('nickname')} errorMessage={errorMessage} data-sentry-element="WithLabel" data-sentry-source-file="CommonEditForm.tsx">
        <div className="flex flex-1 flex-col gap-xs">
          <Input className={`border-input-border h-[48px] ${errors.userName?.message ? 'border-[#FFACB6] focus-within:border-[#FFACB6]' : ''}`} {...register('userName')} maxLength={INPUT_MAX_LENGTH} data-sentry-element="Input" data-sentry-source-file="CommonEditForm.tsx" />
        </div>
      </WithLabel>
      <span className="text-body-md-medium text-alternative">{email}</span>
    </div>;
};